import React from "react";
import CERequirements, {
  CE_REQUIREMENTS_QUERY,
  CeRequirementsParams,
  makeCeId,
} from "components/CeRequirements";
import Layout from "components/common/Layout";
import { getServerSideSEO, SeoPageProps } from "helpers/seo";
import { withEnhancedServerSideProps } from "helpers/withEnhancedProps";
import { USER_FIELDS_OPTIONS_QUERY, UserFieldsOptions, useRouterQuery } from "hooks";
import { CeRequirementFieldsOptionsQuery } from "hooks/__generated__/useCeRequirementFieldsOptions";
import { CE_REQUIREMENT_FIELDS_OPTIONS_QUERY } from "hooks/useCeRequirementFieldsOptions";

const CeRequirementStatePage = ({ title, seo }: SeoPageProps) => {
  const {
    routerQuery: { state },
  } = useRouterQuery<{ state: string }>();

  return (
    <Layout initialMeta={seo}>
      <CERequirements title={title} seo={seo} state={state} />
    </Layout>
  );
};

export default CeRequirementStatePage;

const PAGE_TITLE = "CE Requirements";

export const getServerSideProps = withEnhancedServerSideProps<SeoPageProps, CeRequirementsParams>(
  async ctx => {
    if (ctx.isInitialRequest) {
      const { state } = ctx.query;

      const seoProps = await getServerSideSEO(ctx, makeCeId(state as string, ""), PAGE_TITLE);

      await Promise.all([
        ctx.apolloClient.query({
          query: CE_REQUIREMENTS_QUERY,
          variables: { id: makeCeId(state as string, "") },
        }),
        ctx.apolloClient.query<CeRequirementFieldsOptionsQuery>({
          query: CE_REQUIREMENT_FIELDS_OPTIONS_QUERY,
        }),
        ctx.apolloClient.query<UserFieldsOptions>({ query: USER_FIELDS_OPTIONS_QUERY }),
      ]);

      return {
        props: { ...seoProps, title: `${PAGE_TITLE} for ${seoProps.title}` },
      };
    }

    return {
      props: { title: PAGE_TITLE },
    };
  }
);
